export { default } from "./accordion";
